import { useMutation } from '@tanstack/react-query';
import { Col, Collapse, Row } from 'antd';
import CNPlanApis from 'apis/CNPlanApis';
import ButtonExport from 'components/Button/ButtonExport';
import { useTitle } from 'contexts/TitleProvider';
import { useUser } from 'contexts/UserProvider';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { exportExcel_v2 } from 'utils/constants/exportExcel';
import { IExportExcels } from 'utils/constants/functions';
import TableCNPlanDetail from './TableCNPlanDetail';
import { icons } from 'utils/constants/icons';
const { CaretRightOutlined } = icons;
const arrayItem = [
  {
    id: 1,
    title: 'Doanh thu hóa đơn',
    data: null,
  },
  {
    id: 2,
    title: 'Doanh thu công',
    data: null,
  },
  {
    id: 3,
    title: 'Lãi gộp',
    data: null,
  },
  {
    id: 4,
    title: 'Lợi nhuận trước thuế',
    data: null,
  },
];
const CNPlanDetail = () => {
  const location = useLocation();
  const record = location.state;
  const [planData, setPlanData] = useState<any>([]);
  const { setTitle, setBreadcrumb } = useTitle();
  const childRef = useRef<any>(null);
  const { user } = useUser();
  const {
    isPending: isGetRevenuePlanTeamSale,
    mutate: getRevenuePlanTeamSale,
  } = useMutation({
    mutationFn: (params: {
      page?: number;
      page_size?: number;
      input?: any;
      type?: any;
      isSale?: boolean;
    }) => {
      const { isSale, ...others } = params;

      if (!params.isSale) return CNPlanApis.getRevenuePlanTeamSale(others);
      return CNPlanApis.getRevenueTeamsaleOfUser(others);
    },
    onSuccess: (res, variables) => {
      if (!res.data) return;

      const data = !variables.isSale
        ? res.data.getRevenuePlanTteamsale.items
        : res.data.getRevenueTeamsaleOfUserView.items;

      setPlanData(
        data.map((item: any) => {
          const newItem = {
            ...item,
            tteamSale: item.tteamSale.name,
            tcreateUser:
              item.tcreateUser !== null ? item.tcreateUser.fullName : '',
            tmodifyUser:
              item.tmodifyUser !== null ? item.tmodifyUser.fullName : '',
          };
          return newItem;
        }),
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });
  useEffect(() => {
    if (typeof user === 'undefined') return;

    const plantId = user.plantCode;
    const input = { year: { equals: parseInt(location.state.year) } };

    if (user.isHO || user.isAdmin)
      getRevenuePlanTeamSale({
        input: input,
      });
    else if (user.isCN)
      getRevenuePlanTeamSale({
        input: {
          ...input,
          plantId: { equals: plantId },
        },
      });
    else if (user.isSale) {
      getRevenuePlanTeamSale({
        isSale: true,
        input: {
          userId: { equals: user.id },
        },
      });
    }
  }, [user]);
  useEffect(() => {
    setTitle(`Kết quả phân bổ theo đội bán hàng`);
    setBreadcrumb([
      { title: 'Kế hoạch' },
      { title: `[CN] Kế hoạch`, href: '/cn-plan' },
      { title: `Kết quả phân bổ theo đội bán hàng` },
    ]);
  }, []);

  const handleExportData = useCallback(() => {
    if (!childRef.current) return;
    const planData: IExportExcels = childRef.current.getData();

    exportExcel_v2(
      planData.headerRow,
      planData.datas,
      `Kế Hoạch - [CN] Phân bổ kế hoạch theo đội bán hàng của năm ${record.year}`,
    );
  }, [childRef]);

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'} className="mb-3">
        <Col>
          <ButtonExport onClick={handleExportData} />
        </Col>
      </Row>
      {arrayItem.map((item) => (
        <Collapse
          key={item.id}
          bordered={false}
          defaultActiveKey={item.id}
          expandIcon={({ isActive }) => (
            <CaretRightOutlined
              style={{
                fontSize: '20px',
                color: isActive ? '#0077cc' : 'black',
              }}
              rotate={isActive ? 90 : 0}
            />
          )}
          className="mb-5 bg-white rounded-2xl h-"
        >
          <Collapse.Panel
            key="1"
            header={
              <div className="flex justify-between items-center font-bold">
                {item.title}
                <span className="float-right text-sm text-black font-normal">
                  Đơn vị: triệu VND
                </span>
              </div>
            }
            className="bg-white text-black rounded-full"
          >
            <TableCNPlanDetail
              ref={childRef}
              data={planData}
              loading={isGetRevenuePlanTeamSale}
              plan={{ year: record.year, unitMoney: record.unitMoney }}
            />
          </Collapse.Panel>
        </Collapse>
      ))}
    </>
  );
};

export default CNPlanDetail;
